const TwoSquareIcon = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
        <path
            fill="#DBC848"
            d="M9.75.25A9.75 9.75 0 1 0 19.5 10 9.76 9.76 0 0 0 9.75.25Zm0 18A8.25 8.25 0 1 1 18 10a8.26 8.26 0 0 1-8.25 8.25Zm4.28-8.78a.748.748 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H6a.75.75 0 1 1 0-1.5h5.69L9.97 7.53a.75.75 0 0 1 1.06-1.06l3 3Z"
        />
    </svg>
)
export default TwoSquareIcon
